<template>
  <a-config-provider :locale="antLocale">
    <div class="admin-layout" :class="{ 'mobile-layout': isMobile }">
      <AdminSidebar v-if="showSidebar && !isMobile" />
      <div :style="mainContentStyle" class="main-content-base">

      <!-- 使用 RouterView 來渲染當前活動路由內容 -->
      <!-- 使用 keep-alive 保持頁面狀態 -->
      <div class="tab-content">
        <router-view v-slot="{ Component, route }">
          <keep-alive>
            <component 
              :is="getComponent(Component, route)" 
              v-if="route.meta.keepAlive" 
              :key="route.path"
            />
          </keep-alive>
          <component 
            :is="getComponent(Component, route)" 
            v-if="!route.meta.keepAlive" 
            :key="route.path"
          />
        </router-view>
      </div>
    </div>
  </div>


  </a-config-provider>
</template>

<script setup>
import { ref, computed, inject, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { message } from 'ant-design-vue'
import AdminSidebar from './components/AdminSidebar.vue'
import ProductListViewMobile from './views/ProductListViewMobile.vue'
import { useUserStore } from './stores/user'
import { useBackendSettings } from './stores/backendSettings'
import axios from 'axios'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const { getSidebarActualCollapsed } = useBackendSettings()

// 注入 Ant Design locale
const antLocale = inject('antLocale')

// 設備檢測
const isMobile = ref(false)

function checkIsMobile() {
  if (typeof window === 'undefined') return false
  return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function handleResize() {
  isMobile.value = checkIsMobile()
}

onMounted(() => {
  isMobile.value = checkIsMobile()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

// 在登入頁面不顯示側邊欄，chengshe帳號的當日配送頁面也不顯示側邊欄
const showSidebar = computed(() => {
  if (userStore.user?.username === 'chengshe' && route.name === 'dailyDelivery') {
    return false
  }
  return route.name !== 'login' && userStore.isLoggedIn
})

// 根據設備類型和路由決定顯示哪個組件
function getComponent(Component, route) {
  // 如果是商品列表頁面且為手機設備，使用手機版組件
  if (route.name === 'products' && isMobile.value) {
    return ProductListViewMobile
  }
  return Component
}

// 動態計算主內容區域樣式
const mainContentStyle = computed(() => {
  return {
    flex: 1,
    transition: 'all 0.3s ease'
  }
})







</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
}

.admin-layout.mobile-layout {
  flex-direction: column;
}

/* 將固定寬度和邊距移到動態樣式，這裡只保留基本佈局 */
.main-content-base {
  display: flex;
  flex-direction: column; /* Stack content vertically */
  background-color: #f4f7fa;
  overflow: hidden; /* 保持固定高度，不讓主容器滾動 */
  height: 100vh;
  height: 100dvh; /* 手機瀏覽器網址列會改變可視高度，用動態視窗高度避免底部被切掉 */
  transition: margin-left 0.3s ease, width 0.3s ease;
}

.admin-layout.mobile-layout .main-content-base {
  height: 100vh;
  height: 100dvh;
  width: 100%;
}





/* Style the content area */
.tab-content {
  flex-grow: 1; /* Allow content to fill remaining space */
  overflow: auto; /* 允許內容在固定高度內滾動 */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain; /* 捲到頭尾不帶動外層，避免 iOS 把手勢吃掉 */
  background-color: #f4f7fa;
}

/* 手機改用整頁捲動：內層固定高度容器在 iOS 上會吃掉捲動手勢 */
@media (max-width: 768px) {
  .admin-layout {
    display: block;
  }

  .main-content-base {
    height: auto;
    min-height: 100dvh;
    overflow: visible;
    width: 100%;
  }

  .tab-content {
    overflow: visible;
    padding-bottom: calc(24px + env(safe-area-inset-bottom));
  }
}

</style>

<style>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* 手機由整頁負責捲動，不鎖 html/body */
@media (max-width: 768px) {
  html,
  body {
    height: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>